import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import NearestDriversMobile from "../Pages/NearestDriversMobile";
import OrderDriver from "../Pages/OrderDriver";
import OrderDriverTrace from "../Pages/OrderDriverTrace";
import OrderDriverPickupMobile from "../Pages/OrderDriverPickupMobile";
import OrderRideListMobile from "../Pages/OrderRideListMobile";
import Checkout from "../Components/PaymentGateway";
import OrderStatus from "../Pages/OrderStatus";
import Shipping from "../Pages/Shipping";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "nearestDrivers", element: <NearestDriversMobile /> },
      { path: "orderDriver", element: <OrderDriver /> },
      { path: "orderDriverTrace", element: <OrderDriverTrace /> },
      { path: "orderDriverPickup", element: <OrderDriverPickupMobile /> },

      { path: "mobile/orderRideList/tokenPath/:tokenPath/refreshToken/:refreshToken/userId/:userId", element: <OrderRideListMobile /> },

      { path: "checkout/params/:params/tokenPath/:tokenPath", element: <Checkout /> },
      { path: "order-status", element: <OrderStatus /> },
      { path: "shipping/idTrx/:idTrx", element: <Shipping /> },

      // {
      //   path: "company/:ticker",
      //   element: (
      //     // <ProtectedRoute>
      //     <CompanyPage />
      //     // </ProtectedRoute>
      //   ),
      //   children: [
      //     { path: "company-profile", element: <CompanyProfile /> },
      //   ],
      // },
    ],
  },
]);